import { gql } from "@apollo/client";

export const AddItemErrorMsg = gql`
  mutation AddItemErrorMsg(
    $token: String!
    $customerID: ID!
    $user_details: SubscribedUser!
    $itemID: ID!
    $input: [errMsgs!]!
  ) {
    AddItemErrorMsg(
      token: $token
      customerID: $customerID
      user_details: $user_details
      itemID: $itemID
      input: $input
    )
  }
`;

export const UpdateItemErrorMsg = gql`
  mutation UpdateItemErrorMsg(
    $token: String!
    $customerID: ID!
    $user_details: SubscribedUser!
    $errMsgID: ID!
    $errMsg: String
  ) {
    UpdateItemErrorMsg(
      token: $token
      customerID: $customerID
      user_details: $user_details
      errMsgID: $errMsgID
      errMsg: $errMsg
    )
  }
`;

export const DeleteItemErrorMsg = gql`
  mutation DeleteItemErrorMsg(
    $token: String!
    $customerID: ID!
    $errMsgIds: [ID!]!
    $user_details: SubscribedUser!
  ) {
    DeleteItemErrorMsg(
      token: $token
      customerID: $customerID
      errMsgIds: $errMsgIds
      user_details: $user_details
    )
  }
`;

export const ReOrdertemErrorMsgs = gql`
  mutation ReOrdertemErrorMsgs(
    $token: String!
    $customerID: ID!
    $user_details: SubscribedUser!
    $input: [ReOrderErrMsgs!]!
  ) {
    ReOrdertemErrorMsgs(
      token: $token
      customerID: $customerID
      user_details: $user_details
      input: $input
    )
  }
`;
